import React from "react";
import "./GermanAppQrStyles.css";

import iosQr from "./images/ios.png";
import androidQr from "./images/android.png";

type GermanAppQrProps = {
  iosStoreUrl?: string;
  androidStoreUrl?: string;
  title?: string;
  subtitle?: string;
  compact?: boolean;
};

const GermanAppQr: React.FC<GermanAppQrProps> = ({
  iosStoreUrl,
  androidStoreUrl,
  title = "Get the app",
  subtitle = "Scan the QR code to download",
  compact = false,
}) => {
  const Card = ({
    platform,
    hint,
    qrSrc,
    storeUrl,
    ctaText,
    variant,
  }: {
    platform: string;
    hint: string;
    qrSrc: string;
    storeUrl?: string;
    ctaText: string;
    variant: "ios" | "android";
  }) => {
    const Wrapper: React.ElementType = storeUrl ? "a" : "div";

    return (
      <article className={`qrCard ${variant}`} aria-label={`${platform} QR code`}>
        <div className="qrCardTop">
          <span className={`qrPill ${variant}`}>{platform}</span>
          <span className="qrHint">{hint}</span>
        </div>

        <Wrapper
          className={`qrScanArea ${storeUrl ? "isLink" : ""}`}
          {...(storeUrl
            ? { href: storeUrl, target: "_blank", rel: "noreferrer" }
            : {})}
        >
          <img className="qrImage" src={qrSrc} alt={`${platform} download QR code`} />
          <div className="qrScanOverlay">
            <span className="qrScanText">{storeUrl ? "Tap to open" : "Scan to download"}</span>
          </div>
        </Wrapper>

        {storeUrl ? (
          <a className={`qrCta ${variant}`} href={storeUrl} target="_blank" rel="noreferrer">
            {ctaText}
            <span className="qrArrow" aria-hidden="true">
              →
            </span>
          </a>
        ) : (
          <div className="qrCta disabled" aria-disabled="true">
            Link coming soon
          </div>
        )}
      </article>
    );
  };

  return (
    <section className={`qrSection ${compact ? "compact" : ""}`} aria-label="App download QR codes">
      <div className="qrHeader">
        <h2 className="qrTitle">{title}</h2>
        <p className="qrSubtitle">{subtitle}</p>
      </div>

      <div className="qrGrid">
        <Card
          platform="iOS"
          hint="iPhone / iPad"
          qrSrc={iosQr}
          storeUrl={iosStoreUrl}
          ctaText="Open App Store"
          variant="ios"
        />
        <Card
          platform="Android"
          hint="Phones / Tablets"
          qrSrc={androidQr}
          storeUrl={androidStoreUrl}
          ctaText="Open Google Play"
          variant="android"
        />
      </div>
    </section>
  );
};

export default GermanAppQr;
